import React from "react";

import { Button, Input, Modal, Form } from "antd";
import { SmartButtons } from "utils/interfaces";
import { Control, Controller, FieldErrors, SubmitHandler, UseFormHandleSubmit } from "react-hook-form";
// utils

interface AddSingleModalProps {
  showAddModal: boolean,
  toggleAddModal: () => void,
  handleSubmit: UseFormHandleSubmit<SmartButtons, SmartButtons>,
  errors: FieldErrors<SmartButtons>,
  onSubmit: SubmitHandler<SmartButtons>,
  control: Control<SmartButtons, any, SmartButtons>,
  isValid: boolean,
  isSubmitting: boolean
}

const AddSingleButtonModal: React.FC<AddSingleModalProps> = ({
  showAddModal,
  toggleAddModal,
  handleSubmit,
  errors,
  onSubmit,
  control,
  isValid,
  isSubmitting
}) => {
  return (
    <Modal
        title={'Add Single Button'}
        open={showAddModal}
        onCancel={toggleAddModal}
        closable={!isSubmitting}
        mask={{ closable: !isSubmitting }}
        footer={[
            <Button onClick={toggleAddModal} disabled={isSubmitting}>Cancel</Button>,
            <Button
                onClick={handleSubmit(onSubmit)}
                type="primary"
                disabled={!isValid || isSubmitting}
                loading={isSubmitting}
            >Add</Button>
        ]}
    >
        <Form layout="vertical" preserve={false}>
            <Form.Item
                label="Serial Number"
                validateStatus={errors.button_sn ? "error" : ""}
                help={errors.button_sn?.message}
            >
                <Controller
                    name="button_sn"
                    control={control}
                    rules={{required: "Serial Number is required"}}
                    render={({ field }) => (
                        <Input
                            {...field}
                            placeholder="Enter Serial Number"
                            onChange={(e) => {
                                const value = e.target.value.replace(/\s+/g, "");
                                field.onChange(value);
                            }}
                            value={field.value}
                        />
                    )}
                />
            </Form.Item>
            <Form.Item
                label="MAC Address"
                validateStatus={errors.button_mac ? "error" : ""}
                help={errors.button_mac?.message}
            >
                <Controller
                    name="button_mac"
                    control={control}
                    rules={{
                        required: "MAC Address is required",
                        pattern: {
                            value: /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/,
                            message: "Invalid MAC address format (xx:xx:xx:xx:xx:xx)",
                        },
                    }}
                    render={({ field }) => (
                        <Input
                            {...field}
                            maxLength={17}
                            placeholder="Enter MAC Address"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[^0-9A-Fa-f]/g, "").toLowerCase();
                                value = value.match(/.{1,2}/g)?.join(":").substring(0, 17) || "";
                                field.onChange(value);
                            }}
                            value={field.value}
                        />
                    )}
                />
            </Form.Item>
        </Form>
    </Modal>
  );
};
export default AddSingleButtonModal;
